import React from 'react';
import TransactionDetailReceipt from 'components/receipt/transactions/TransactionDetailReceipt';
import { connect } from 'react-redux';
import {
  showResendEmailModal,
  showRefundBreakdownModal,
  showOldRefundModal,
} from 'actions/reports/transactions';
import PropTypes from 'prop-types';
import { Popover, OverlayTrigger } from 'react-bootstrap';
import { isFullSiteMode } from 'utils/fullSite';
import { EWALLET_TYPE } from 'utils/paymentMethodConstants';
import { find } from 'lodash';
import withFeatureFlag from 'hocs/withFeatureFlags';
import styles from './TransactionDetail.css';

class TransactionDetail extends React.Component {
  render() {
    const {
      transactionDetail,
      paymentMethods,
    } = this.props.data.reports.transactions;
    let paymentMethodTransaction;
    if (transactionDetail != null && paymentMethods.length > 0) {
      paymentMethodTransaction = paymentMethods.find(
        paymentMethod => paymentMethod.code === transactionDetail.payment_type
      );
    }
    return (
      transactionDetail != null && (
        <div className={styles['receipt-box']}>
          {/* -- TOP ACTION BOX -- */}
          <div
            className={
              !isFullSiteMode()
                ? styles['action-box-top']
                : styles['action-box-top-full-site']
            }
          >
            <button
              className="btn btn-default"
              onClick={this._onClickResendReceipt}
            >
              Resend Receipt
            </button>
            {this._renderRefundButton(
              paymentMethodTransaction,
              transactionDetail
            )}
          </div>
          {/* -- END TOP ACTION BOX -- */}
          {/* -- RECEIPT CONTENT -- */}
          <div
            className={
              !isFullSiteMode()
                ? `${styles['receipt-container']} receipt-container-custom`
                : `${
                    styles['receipt-container-full-site']
                  } receipt-container-custom`
            }
          >
            <TransactionDetailReceipt paymentDetail={transactionDetail} />
          </div>
          {/* -- END RECEIPT CONTENT -- */}
          {/* -- BOTTOM ACTION BOX -- */}
          <div
            className={
              !isFullSiteMode()
                ? styles['action-box-bottom']
                : styles['action-box-bottom-full-site']
            }
          >
            <button
              className="btn btn-primary pull-right"
              onClick={this._onClickDoneButton}
            >
              Done
            </button>
          </div>
          {/* - END BOTTOM ACTION BOX -- */}
        </div>
      )
    );
  }

  _renderRefundButton(paymentMethodTransaction, transactionDetail) {
    if (!transactionDetail.refundable) {
      return null;
    }

    const popover = (
      <Popover id="refundCardTransaction" placement="bottom">
        Card transaction can only be refunded from the mobile device
      </Popover>
    );

    if (transactionDetail.payment_type === 'card') {
      return (
        <OverlayTrigger overlay={popover}>
          <button type="button" className="btn btn-default pull-right">
            Issue Refund
          </button>
        </OverlayTrigger>
      );
    }

    if (
      this._isRefundablePaymentMethod(
        paymentMethodTransaction,
        transactionDetail
      )
    ) {
      return (
        <button
          className="btn btn-default pull-right"
          onClick={
            this._isRefundBreakdown()
              ? this._onClickIssueRefund
              : this._onClickOldIssueRefund
          }
        >
          Issue Refund
        </button>
      );
    }

    return (
      <button type="button" className="btn btn-default pull-right" disabled>
        Issue Refund
      </button>
    );
  }

  _isRefundablePaymentMethod(paymentMethodTransaction, transactionDetail) {
    if (this.props.dynamicDisableRefund) {
      return (
        paymentMethodTransaction !== undefined &&
        paymentMethodTransaction !== null &&
        paymentMethodTransaction.isRefundable
      );
    }
    return (
      ![
        'card',
        'online_orders',
        'gofood',
        'gostore_cards',
        'gostore_gopay',
        'gostore_bca_va',
        'gostore_bni_va',
        'gostore_bri_va',
        'gostore_permata_va',
        'gostore_mandiri_bill_payment',
        'gostore_other_va',
      ].includes(transactionDetail.payment_type) &&
      !find(EWALLET_TYPE, t => {
        return t === transactionDetail.payment_type;
      })
    );
  }

  _onClickDoneButton = () => {
    this.props.onClickDoneButton();
  };

  _onClickResendReceipt = () => {
    this.props.dispatch(showResendEmailModal());
  };

  _onClickIssueRefund = () => {
    this.props.dispatch(showRefundBreakdownModal());
  };

  _onClickOldIssueRefund = () => {
    this.props.dispatch(showOldRefundModal());
  };

  /**
   * Determine whether the transaction detail can be refunded with refund breakdown
   * @return boolean
   * @private
   */
  _isRefundBreakdown = () => {
    const { transactionDetail } = this.props.data.reports.transactions;
    if (
      transactionDetail.payment_refunds &&
      transactionDetail.payment_refunds.length > 0
    ) {
      let hasOldRefund = false;
      transactionDetail.payment_refunds.forEach(refund => {
        if (!refund.is_refund_breakdown) {
          hasOldRefund = true;
        }
      });
      return !hasOldRefund;
    }
    return transactionDetail.refund_availability.length > 0;
  };
}

const mapStateToProps = state => {
  return {
    data: {
      reports: {
        transactions: state.reports.transactions,
      },
    },
  };
};

TransactionDetail.propTypes = {
  onClickDoneButton: PropTypes.func,
  dispatch: PropTypes.func,
};

const connected = connect(mapStateToProps)(TransactionDetail);

const mapFlagToProps = flags => {
  return {
    dynamicDisableRefund: flags.dynamicDisableRefund,
  };
};

export default withFeatureFlag(mapFlagToProps)(connected);
